import { Panel } from "@/components/ui/Panel";
import { cn } from "@/lib/utils";

/** One finding as the server words it: what kind it is, and its note. */
export interface ListedFinding {
  kind: string;
  note: string;
}

/**
 * What a stage found, each finding in its own words as a warning row.
 *
 * A Novelty position, a claim and a claim set each carry findings the attorney
 * reads and decides on; none of them is an action, so the list offers none.
 */
export function FindingList({
  findings,
  testId,
  className,
}: {
  findings: readonly ListedFinding[];
  testId: string;
  className?: string;
}) {
  if (findings.length === 0) return null;
  return (
    <ul className={cn("grid gap-1.5", className)}>
      {findings.map((finding, at) => (
        <Panel
          as="li"
          key={`${String(at)}:${finding.kind}`}
          shape="row"
          pad="tight"
          tone="warning"
          data-testid={testId}
          data-kind={finding.kind}
          className="text-[12px]"
        >
          {finding.note}
        </Panel>
      ))}
    </ul>
  );
}
